import type { Routes } from "@angular/router";
import { MainLayoutComponent } from "../layout/main-layout/main-layout.component";

export default [
	{
		path: "whistleblower",
		component: MainLayoutComponent,
		children: [
			{
				path: "",
				loadComponent: () =>
					import("./whistleblower-index/whistleblower-index.component").then(
						(m) => m.WhistleblowerIndexComponent,
					),
			},
			{
				path: "report",
				loadComponent: () =>
					import("./whistleblower-report/whistleblower-report.component").then(
						(m) => m.WhistleblowerReportComponent,
					),
			},
			{
				path: "cases",
				loadComponent: () =>
					import("./whistleblower-cases/whistleblower-cases.component").then(
						(m) => m.WhistleblowerCasesComponent,
					),
			},
			{
				path: "cases/status",
				loadComponent: () =>
					import(
						"./whistleblower-cases-status/whistleblower-cases-status.component"
					).then((m) => m.WhistleblowerCasesStatusComponent),
			},
			{
				path: "case/detail/:id",
				loadComponent: () =>
					import(
						"./whistleblower-case-detail/whistleblower-case-detail.component"
					).then((m) => m.WhistleblowerCaseDetailComponent),
			},
			{
				path: "policy",
				loadComponent: () =>
					import("./whistleblower-policy/whistleblower-policy.component").then(
						(m) => m.WhistleblowerPolicyComponent,
					),
			},
			{
				path: "faq",
				loadComponent: () =>
					import("./whistleblower-faq/whistleblower-faq.component").then(
						(m) => m.WhistleblowerFaqComponent,
					),
			},
			{
				path: "question/:questionId",
				loadComponent: () =>
					import(
						"./whistleblower-question/whistleblower-question.component"
					).then((m) => m.WhistleblowerQuestionComponent),
			},
			{
				path: "submit",
				loadComponent: () =>
					import("./whistleblower-submit/whistleblower-submit.component").then(
						(m) => m.WhistleblowerSubmitComponent,
					),
			},
			{
				path: "create/incident",
				loadComponent: () =>
					import(
						"./whistleblower-create-incident/whistleblower-create-incident.component"
					).then((m) => m.WhistleblowerCreateIncidentComponent),
			},
		],
	},
] satisfies Routes;
